/* Free-shipping-meter: alle instanties (sectie, sticky bar, cart-drawer)
   updaten live mee met de winkelwagen. Bij een cart-event halen we het
   actuele totaal op via /cart.js (klein JSON) en rekenen client-side bij —
   geen zware sectie-refetches. De drawer-instantie wordt daarnaast sowieso
   server-side ververst bij elke cart-wijziging. */

(function () {
  if (customElements.get('free-shipping-meter')) return;

  const money = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });

  class FreeShippingMeter extends HTMLElement {
    connectedCallback() {
      this.refresh = this.refresh.bind(this);
      // add-to-cart, én wijzigen/verwijderen in de drawer (krown:cart:update)
      document.addEventListener('krown:cart:add', this.refresh);
      document.addEventListener('krown:cart:update', this.refresh);
      document.addEventListener('cart:refresh', this.refresh);

      // Waterdicht vangnet: niet elk cart-pad vuurt een event (bv. volledig
      // legen), maar het thema werkt bij élke wijziging de teller in de
      // header bij — die observeren dekt alle paden.
      const counter = document.querySelector('[data-header-cart-count]');
      if (counter) {
        this._observer = new MutationObserver(this.refresh);
        this._observer.observe(counter, { childList: true, characterData: true, subtree: true });
      }
    }
    disconnectedCallback() {
      document.removeEventListener('krown:cart:add', this.refresh);
      document.removeEventListener('krown:cart:update', this.refresh);
      document.removeEventListener('cart:refresh', this.refresh);
      if (this._observer) this._observer.disconnect();
    }
    async refresh() {
      try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        this.update(cart.total_price);
      } catch (e) {
        console.error('Error', e);
      }
    }
    update(total) {
      const threshold = parseInt(this.dataset.threshold, 10) || 0;
      const remaining = Math.max(0, threshold - total);
      const pct = threshold > 0 ? Math.min(100, Math.round((total / threshold) * 100)) : 100;

      const amount = this.querySelector('[data-fsm-amount]');
      const rem = this.querySelector('[data-fsm-remaining]');
      const done = this.querySelector('[data-fsm-reached]');
      const fill = this.querySelector('[data-fsm-fill]');

      if (amount) amount.textContent = money.format(remaining / 100);
      if (rem) rem.hidden = remaining === 0;
      if (done) done.hidden = remaining > 0;
      if (fill) {
        fill.style.width = pct + '%';
        fill.classList.toggle('free-shipping-meter__fill--done', remaining === 0);
      }
    }
  }

  customElements.define('free-shipping-meter', FreeShippingMeter);
})();
